import { Component, Input, OnInit } from '@angular/core';
import { ContactDetailsService } from '../contact-details.service';
import { HistoryService } from './history.service';
import { ContactHistory } from '../contacts-details.model';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { getLimitsSelector } from '../../shared/limits/limits.reducer';
import { AccountLimits } from '../../account/account.model';
import { hideRecordingsNotAvailableInPlan } from '../../shared/limits/limitsHelper';

@Component({
  selector: 'cc-contact-history',
  templateUrl: './contact-history.component.html',
  styleUrls: ['./contact-history.component.scss']
})
export class ContactHistoryComponent implements OnInit {
  @Input() recordId: number;
  @Input() eventId: number;
  public limit = 5;
  public history: ContactHistory[];
  public availableHistoryTypes = ['ALL'];
  public visibleHistoryEvents: Map<string, boolean> = new Map();
  public expand: boolean;
  private recordingsStorageDays = 0;

  constructor(
    public contactDetailsService: ContactDetailsService,
    public historyService: HistoryService,
    private store: Store<IState>
  ) {}

  ngOnInit() {
    this.store.select(getLimitsSelector).subscribe((limits: AccountLimits) => {
      this.recordingsStorageDays = limits.recordingsStorageDays;
    });

    this.getAvailableHistoryTypes();
    this.loadHistory();
    this.visibleHistoryEvents[this.eventId] = true;
    this.historyService.onUpdateHistory.subscribe((res: ContactHistory[]) => {
      this.history = res && res.map(history => hideRecordingsNotAvailableInPlan(this.recordingsStorageDays, history));
    });
  }

  isEventVisible(id: number): boolean {
    return this.visibleHistoryEvents[id];
  }

  expandOrCollapseAll(open: boolean) {
    this.expand = open;
    this.history.forEach(e => (this.visibleHistoryEvents[e.id] = open));
  }

  getAvailableHistoryTypes() {
    this.contactDetailsService.getAvailableHistoryTypes(this.recordId).subscribe(res => {
      this.availableHistoryTypes = [...this.availableHistoryTypes, ...res];
    });
  }

  getEventType(event) {
    if (event.customStatus === 'INCOMING_CALL_NOT_ANSWERED' && event.finishType === 'INCOMING_CALL_VOICEMAIL') {
      return event.finishType;
    }
    return event.customStatus ? event.customStatus : event.type;
  }

  isDataInEvent(event) {
    return event.callLength || event.name || event.clientMsisdn || event.newMsisdn || event.oldMsisdn;
  }

  isAvailableMoreHistoryAfter() {
    return this.historyService.isAvailableMoreHistoryAfter();
  }

  isAvailableMoreHistoryBefore() {
    return this.historyService.isAvailableMoreHistoryBefore();
  }

  prependHistory() {
    this.historyService.prependHistory(this.recordId);
  }

  appendHistory() {
    this.historyService.appendHistory(this.recordId);
  }

  loadHistory() {
    this.historyService.refreshHistory(this.recordId, this.eventId);
  }

  scrollTop() {
    (function smoothscroll() {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 8);
      }
    })();
  }

  toggleExpandEvent(eventId) {
    this.visibleHistoryEvents[eventId] = !this.visibleHistoryEvents[eventId];
  }
}
